export const PINKSALE_URL =
  "https://www.pinksale.finance/launchpad/base/0x15e3214aD1DB6B36aA189933E838Eb39b643A1a6";
export const TELEGRAM_URL = "https://t.me/AfterBurnReFi";
export const X_URL = "https://x.com/AFTBRN63";
